<template>
  <transition name="modal">
    <div class="modal-mask" :id="id">
      <div class="modal-wrapper">
        <div class="modal-dialog modal-container">
          <div class="modal-content">
            <div class="modal-header" v-if="!hideHeader">
              <slot name="modal-header">
                <h5 class="modal-title">
                  {{ title }}
                </h5>
              </slot>
            </div>

            <div class="modal-body">
              <slot></slot>
            </div>

            <div class="modal-footer">
              <slot name="modal-footer">
                <button type="button" class="btn cl-btn close-btn" @click="$emit('cancel')" v-if="isCloseButton">
                  {{ closeTitle }}
                </button>
                <button type="button" class="btn cl-btn" @click="$emit('ok')" :disabled="okDisabled">
                  <span v-if="!okBusy">{{ okTitle }}</span>
                  <LoadingBounce v-else></LoadingBounce>
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'custom-modal',

    props: {
      id: String,
      title: String,
      okTitle: {
        type: String,
        default: '확인',
      },
      closeTitle: {
        type: String,
        default: '취소',
      },
      okDisabled: {
        type: Boolean,
        default: false,
      },
      okBusy: {
        type: Boolean,
        default: false,
      },
      hideHeader: {
        type: Boolean,
        default: false,
      },
      isCloseButton: {
        type: Boolean,
        default: true,
      },
    },
  };
</script>

<style lnag="scss" scoped>

  .close-btn {
    background-color: #ffffff;
    border: solid 1px #d9d9d9;
    color: rgba(0, 0, 0, 0.54);
  }

</style>




// WEBPACK FOOTER //
// CustomModal.vue?ba0d16e6